import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Crypto } from "../context/CryptoContext";
import axios from "axios";
import { SingleCoin } from "../config/api";
import {
  Button,
  LinearProgress,
  makeStyles,
  Typography,
} from "@material-ui/core";
import CoinInfo from "../components/CoinInfo";
import ReactHtmlParser from "react-html-parser";
import { numberWithCommas } from "../components/banner/Carousel";
import { doc, onSnapshot, setDoc } from "firebase/firestore";
import { db } from "../firebase";
const CoinPage = () => {
  const { id } = useParams();
  const [coin, setCoin] = useState();
  const { currency, symbol, user, watchList, setAlert, setWatchList} =
    useContext(Crypto);
  const fetchCoin = async () => {
    const { data } = await axios.get(SingleCoin(id));
    setCoin(data);
  };
  useEffect(() => {
    fetchCoin();
  }, [currency]);
  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        alignItems: "center",
      },
    },
    sidebar: {
      width: "30%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: 25,
      borderRight: "2px solid grey",
    },
    heading: {
      fontWeight: "bold",
      marginBottom: 20,
      fontFamily: "Montserrat",
    },
    description: {
      width: "100%",
      fontFamily: "Montserrat",
      padding: 25,
      paddingBottom: 15,
      paddingTop: 0,
      textAlign: "justify",
    },
    marketData: {
      alignSelf: "start",
      padding: 25,
      paddingTop: 10,
      width: "100%",
      [theme.breakpoints.down("md")]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "center",
      },
      [theme.breakpoints.down("xs")]: {
        alignItems: "start",
      },
    },
  }));
  const classes = useStyles();
  const inWatchList = watchList.includes(coin?.id);

  const addToWatchList = async () => {
    const coinRef = doc(db, "watchList", user.uid);
    try {
      await setDoc(coinRef, {
        coin: watchList ? [...watchList, coin?.id] : [coin.id],
      });
      setAlert({
        open: true,
        message: "Coin added to watchlist!",
        type: "success",
      });
    } catch (error) {
      setAlert({
        open: true,
        message: `${error.message}`,
        type: "error",
      });
    }
  };
const removeFromWatchList = async() =>{
  const coinRef = doc(db, "watchList", user.uid);
  try {
    await setDoc(coinRef, {
      coin: watchList.filter((watch)=> watch !== coin.id)},
      {
        merge:true
      }
    );
    setAlert({
      open: true,
      message: "Removed from  watchlist!",
      type: "success",
    });
  } catch (error) {
    setAlert({
      open: true,
      message: `${error.message}`,
      type: "error",
    });
  }
}

  useEffect(() => {
    if (user) {
      const coinRef = doc(db, "watchList", user.uid);
      var unSubsribe = onSnapshot(coinRef, (coin) => {
        if (coin.exists()) {
          setWatchList(coin.data().coin);
        } else {
          console.log("no items in the watchlist");
        }
      });
      return () => {
        unSubsribe();
      };
    }
  }, [user]);
  if (!coin) return <LinearProgress style={{ backgroundClip: "gold" }} />;
  return (
    <div className={classes.container}>
      <div className={classes.sidebar}>
        <img
          src={coin?.image.large}
          alt={coin?.name}
          height={"200"}
          style={{ marginBottom: 20 }}
        />
        <Typography variant="h6" className={classes.heading}>
          {coin?.name}
        </Typography>
        <Typography variant="subtitle1" className={classes.description}>
          {ReactHtmlParser(coin?.description.en.split(".")[0])}
        </Typography>
        <div className={classes.marketData}>
          <span style={{ display: "flex" }}>
            <Typography variant="h5" className={classes.heading}>
              Rank:
            </Typography>
            &nbsp; &nbsp;
            <Typography style={{ fontFamily: "Montserrat" }}>
              {numberWithCommas(coin?.market_cap_rank)}
            </Typography>
          </span>
          <span style={{ display: "flex" }}>
            <Typography variant="h5" className={classes.heading}>
              Current price:
            </Typography>
            &nbsp; &nbsp;
            <Typography style={{ fontFamily: "Montserrat" }}>
              {symbol}
              {numberWithCommas(
                coin?.market_data.current_price[currency.toLowerCase()]
              )}
            </Typography>
          </span>
          <span style={{ display: "flex" }}>
            <Typography variant="h5" className={classes.heading}>
              Market cap:{""}
            </Typography>
            &nbsp; &nbsp;
            <Typography style={{ fontFamily: "Montserrat" }}>
              {symbol}
              {numberWithCommas(
                coin?.market_data.market_cap[currency.toLowerCase()]
                  .toString()
                  .slice(0, -6)
              )}
              M
            </Typography>
          </span>
          {user && (
            <Button
              variant="outlined"
              style={{
                width: "100%",
                height: 40,
                backgroundColor:inWatchList?"red": "#EEBC1D",
              }}
              onClick={ inWatchList? removeFromWatchList : addToWatchList}
            >
              {inWatchList ? "Remove From WatchList" : "Add to WatchList"}
            </Button>
          )}
        </div>
      </div>
      <CoinInfo coin={coin} />
    </div>
  );
};

export default CoinPage;
